import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import moment from '../../../common/moment'
import Component from '../components/calendar.step.jsx'
import actions from '../actions/calendar'
import depositActions from '../actions/deposit'
import startActions from '../actions/start'
import addressActions from '../actions/address'
import costsActions from '../actions/costs'
import summaryActions from '../actions/summary'
import {push} from 'react-router-redux'

const MIN_DATE_DIFF_MINUTES = 120

class Container extends React.Component {

  constructor(props) {
    super(props)
    props.getTransaction()
    props.getAddresses()
    props.getUnavailableDates()
    props.getCosts()
    props.getConfigKey()
  }

  continue = () => {
    this.props.modifyTransaction()
      .then(() => this.props.requestNextStep())
  }

  goToAddress = () => {
    this.props.requestSpecificStep('address', 'calendar', 'calendar')
  }

  filterTimeSlots = () => {
    const today = moment()
    return this.props.timeslots.filter(t => {
      const date = moment(this.props.dateSelected).hour(t.get('Hour')).minute(t.get('Minute'))
      const diff = date.diff(today, 'minutes')
      return diff >= MIN_DATE_DIFF_MINUTES
    })
  }

  render() {
    return (
      <Component
        {...this.props}
        continue={this.continue}
        goToAddress={this.goToAddress}
        timeslots={this.filterTimeSlots()}
      />
    )
  }

  static propTypes = {
    getUnavailableDates: PropTypes.func.isRequired,
    getTransaction: PropTypes.func.isRequired,
    getAddresses: PropTypes.func.isRequired,
    getCosts: PropTypes.func.isRequired,
    modifyTransaction: PropTypes.func.isRequired,
  }
}

const mapStateToProps = (state, props) => {
  const data = state.ui.depositV2.timeslot
  const startData = state.ui.depositV2.start
  return {
    dateSelected: data.get('date'),
    unavailableDates: data.get('unavailableDates').toArray(),
    timeslotSelected: data.get('timeslot'),
    timeslots: data.get('timeslots').toArray(),
    isCalendarLoading: data.get('isFetchingDates') || startData.get('isFetching'),
    isTimeSlotLoading: data.get('isFetchingTimeslots'),
    isAddressLoading: data.get('isFetchingAddresses') || startData.get('isFetching'),
    isButtonLoading: data.get('isModifying') || props.loading,
    isButtonDisabled: data.get('date') === null,
    error: data.get('error'),
    address: startData.getIn(['transaction', 'ID']) ? startData.getIn(['transaction', 'ClientAddress']).Address : '',
    addresses: data.get('addresses').toArray(),
    addressSelected: data.get('address'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectDate: date => dispatch(actions.selectDate(date)),
    selectTimeslot: timeslot => dispatch(actions.selectTimeslot(timeslot)),
    getUnavailableDates: () => dispatch(actions.getUnavailableDates()),
    getTimeslots: () => dispatch(actions.getTimeslots()),
    setStep: step => dispatch(depositActions.setStep(step)),
    modifyTransaction: () => dispatch(actions.modifyTransaction()),
    getTransaction: () => dispatch(startActions.getTransaction()),
    getAddresses: () => dispatch(addressActions.fetch()),
    selectAddress: (id) => dispatch(addressActions.setSelected(id)),
    openCosts: () => dispatch(costsActions.setOpen(true)),
    getCosts: () => dispatch(costsActions.fetch()),
    getConfigKey: () => dispatch(summaryActions.getConfigKey()),
    updateUrl: () => dispatch(push({search: '?s=calendario'})),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/depositV2/containers/calendar.js